import { Button } from '@dtx-company/design-system/src'
import { FC, MouseEventHandler, ReactNode } from 'react'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'

type PrismicUpsellModalContentCTAButtonProps = {
  children?: ReactNode
  heapId?: string
  size?: 'small' | 'medium' | 'large'
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export const PrismicUpsellModalContentCTAButton: FC<PrismicUpsellModalContentCTAButtonProps> = ({
  children,
  heapId,
  size,
  onClick
}) => {
  return (
    <Button
      onClick={e => {
        fireAnalyticsEvent(`${heapId || 'PrismicUpsellModalContent'}_CTAButton_Clicked`)
        onClick?.(e)
      }}
      fullWidth
      size={size}
    >
      {children}
    </Button>
  )
}
